import { Injectable, EventEmitter } from '@angular/core';
import { ProjectData } from 'src/app/entities/project-data.entity';
import { Utils } from 'src/app/utils.module';

@Injectable({
	providedIn: 'root'
})
export class BuilderHistorialService {
	public onUpdateRenderer: EventEmitter<ProjectData> = new EventEmitter();
	private historialBackward: string[] = [];
	private historialForward: string[] = [];

	public historialBack() {
		// No tiene que destruir el original.
		if (this.historialBackward.length < 2) return;
		
		// Pasar el actual Back a Forward.
		this.historialForward.push(this.historialBackward.pop());
		// Obtener el Back restante.
		let data = this.historialBackward[this.historialBackward.length - 1];
		let dataObj = JSON.parse(data);
		localStorage.setItem(Utils.CURRENT_PROJECT, data);
		this.onUpdateRenderer.emit(dataObj);
	}

	public historialNext() {
		if (this.historialForward.length == 0) return;
		let data = this.historialForward.pop();
		let dataObj = JSON.parse(data);

		let perimeters = [];
		// Eliminar perímetros con menos de dos elementos.
		for (let p of dataObj.perimetro) {
			if (p.coordenadas.length > 1) {
				perimeters.push(p);
			}
		}
		dataObj.perimetro = perimeters;

		this.historialBackward.push(data);
		localStorage.setItem(Utils.CURRENT_PROJECT, data);
		this.onUpdateRenderer.emit(dataObj);
	}

	public setHistorialX(mode: number): void {
		// -1 atrás  1 adelante
		if (mode >= 0) {
			if (this.historialForward.length > 0) {
				this.historialBackward.push(this.historialForward.pop());
			}
		} else {
			if (this.historialBackward.length > 0) {
				this.historialForward.push(this.historialBackward.pop());
			}
		}
		let data = JSON.parse(this.historialBackward[this.historialBackward.length - 1]);
		localStorage.setItem(Utils.CURRENT_PROJECT, this.historialBackward[this.historialBackward.length - 1]);
		this.onUpdateRenderer.emit(data);
	}

	public addHistorial(projectData: ProjectData): void {
		this.historialForward = [];
		this.historialBackward.push(JSON.stringify(projectData));
	}

	public clearHistorial(): void {
		this.historialBackward = [];
		this.historialForward = [];
	}

	public get hasHistorialForward(): boolean { return this.historialForward.length > 0; }

	public get hasHistorialBackward(): boolean { return this.historialBackward.length > 1; }
}
